import "./EditFoodModal.css";
import FoodForm from "../FoodForm/FoodForm";

function EditFoodModal({
  open,
  food,
  onClose,
  onSubmit,
  loading = false,
}) {
  if (!open || !food) return null;

  const handleSubmit = (updatedFood) => {
    onSubmit(food._id, updatedFood);
  };

  return (
    <div
      className="modal-overlay"
      onClick={onClose}
    >
      <div
        className="food-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="food-modal-header">

          <h2>Edit Food</h2>

          <button
            className="close-btn"
            onClick={onClose}
          >
            ✕
          </button>

        </div>

        <div className="food-modal-body">

          <FoodForm
            initialData={food}
            onSubmit={handleSubmit}
            loading={loading}
          />

        </div>

      </div>
    </div>
  );
}

export default EditFoodModal;